import { Injectable } from '@angular/core';
import {
  SelectItemDataModel,
  SelectItemModel,
} from 'src/app/api/common/models/select-item.model';

@Injectable({
  providedIn: 'root',
})
export class ObjectUtilService {
  constructor() {}

  copyObject(obj: any) {
    //copy object no reference
    return JSON.parse(JSON.stringify(obj));
  }

  getKeyByValue(object: any, value: any) {
    return Object.keys(object).find((key) => object[key] === value);
  }

  isEmpty(val: any) {
    return val == null || val == undefined || !(Object.keys(val) || val).length;
  }

  getDescendantProp(obj: any, desc: string) {
    return desc.split('.').reduce((a, b) => a[b], obj);
  }

  addOptionAll(
    org: SelectItemModel<any>[],
    isAddAllOption: boolean = true
  ): SelectItemModel<any>[] {
    if (isAddAllOption) {
      org = org ?? [];
      let optionAll: SelectItemModel<any> = {
        label: 'All',
        value: null,
      };
      org.unshift(optionAll);
      return org;
    } else {
      return org;
    }
  }

  addOptionAllData(
    org: SelectItemDataModel<any, any>[],
    isAddAllOption: boolean = true
  ): SelectItemDataModel<any, any>[] {
    if (isAddAllOption) {
      org = org ?? [];
      let optionAll: SelectItemDataModel<any, any> = {
        label: 'All',
        value: null,
      };
      org.unshift(optionAll);
      return org;
    } else {
      return org;
    }
  }

  iterate(obj: any) {
    const stack = [obj];
    while (stack?.length > 0) {
      const currentObj = stack.pop();
      Object.keys(currentObj).forEach((key) => {
        console.log(`key: ${key}, value: ${currentObj[key]}`);
        if (typeof currentObj[key] === 'object' && currentObj[key] !== null) {
          stack.push(currentObj[key]);
        }
      });
    }
  }

  equals(obj1: any, obj2: any) {
    //  console.log(JSON.stringify(obj1), JSON.stringify(obj2));
    return JSON.stringify(obj1) === JSON.stringify(obj2);
  }
}
